import api from './api';
import request from './request';
import loginProvider from './login-provider';
import spinner from './spinner';
import storage from './storage';
import dictionaries from './dictionaries';
import utils from './utils';
import events from './events';

export default {
	api,
	request,
	loginProvider,
	spinner,
	storage,
	dictionaries,
	utils,
	events
};

export {
	api,
	request,
	loginProvider,
	spinner,
	storage,
	dictionaries,
	utils,
	events
};
